const activities = {
  activitiesPage: {
    header: {
      overline: "COMMUNAUTÉ & PARTAGE",
      titlePrefix: "Activités",
      titleHighlight: "publiques",
      subtitle: "Partage d’expérience via conférences, publications et formations pour faire avancer la Data Science et l’IA.",
    },
    errors: {
      load: "Erreur lors du chargement des activités : {{error}}",
    },
    card: {
      explore: "Explorer l’activité",
    },
    cta: {
      titlePrefix: "Intervenant pour votre",
      titleHighlight: "événement",
      subtitle:
        "Vous cherchez un speaker sur l’IA, la Data Science ou l’architecture SaaS ? Discutons de la valeur que je peux apporter à votre conférence, meetup ou formation.",
      button: "Me contacter",
    },
  },
  activityDetail: {
    errors: {
      notFound: "Activité introuvable",
    },
    backToList: "Retour aux activités",
    sections: {
      overview: "Aperçu",
      gallery: "Galerie",
    },
    sidebar: {
      takeAction: "Passer à l’action",
      viewResource: "Voir la ressource",
      contactAboutThis: "Me contacter à ce sujet",
      relatedTitle: "Vous pourriez aussi aimer",
    },
  },
};

export default activities;
